module.exports = __webpack_public_path__ + "img/climate_actions_solar_energy.168913f.svg";